'use client'

import { useEffect } from 'react'
import { ErrorState } from '@platform/errorzen-react'
import { captureError } from '@platform/observezen-react'

/**
 * Catches crashes in route segments outside the authenticated shell — login,
 * admin-login, (auth), aws. Those routes render no chrome, so this centres in
 * the viewport rather than in a main area. Ref: ASC-7832.
 */
export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    captureError(error)
  }, [error])

  return (
    <div className="flex items-center justify-center min-h-screen p-6">
      <ErrorState
        title="Something went wrong"
        description="We couldn't load this page. Please try again."
        supportId={error.digest}
        retryable
        onRetry={reset}
      />
    </div>
  )
}
